/* eslint-disable no-debugger */
import { takeLatest, put, all, call } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
import {
	bankTransactionDetailsAdd,
	bankTransactionDetailsDelete,
	bankTransactionDetailsFetch,
	bankTransactionDetailsUpdate,
	bankTransactionListGet,
	checkBranchEodValues,
	modelValues,
	UpdateTransactionValues,
} from './bankTransaction.services';
import {
	addBankTransactionDetailsFailure,
	addBankTransactionDetailsResponseChanged,
	addBankTransactionDetailsSuccess,
	checkBranchEODChanged,
	checkBranchEODFailure,
	checkBranchEODSuccess,
	deleteBankTransactionDetailsFailure,
	deleteBankTransactionDetailsResponseChanged,
	deleteBankTransactionDetailsSuccess,
	fetchBankTransactionDetailsFailure,
	fetchBankTransactionDetailsResponseChanged,
	fetchBankTransactionDetailsSuccess,
	getBankTransactionListFailure,
	getBankTransactionListResponseChanged,
	getBankTransactionListSuccess,
	getModelValuesFailure,
	getModelValuesResponseChanged,
	getModelValuesSuccess,
	selectedTransactionApproveChanged,
	selectedTransactionApproveFailure,
	selectedTransactionApproveSuccess,
	updateBankTransactionDetailsFailure,
	updateBankTransactionDetailsResponseChanged,
	updateBankTransactionDetailsSuccess,
} from './bankTransaction.action';
import BankTransactionType from './bankTranscation.types';

/** *********************  START GET BANK_TRANSACTION LIST  ******************** */
export function* bankTransactionDetailsListGet({ payload }: any) {
	try {
		const key = 'GetCompanyTranscationEntryListKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			InputSearch: payload.inputSearch,
			SearchType: payload.SearchType,
			UserLevel: payload.userLevel,
			InfogID: payload.InfogID,
			BranchID: payload.branchID,
			CreatedFor: payload.userID,
			InfogCompanyID: payload.infogCompanyID,
			TranscationType: 'Bank',
			TransactionApproveStatus: payload.activeTab,
			Type: payload.type,
			CreatedBy: payload.userID,
			Limit: payload.limit,
			CompanyID: payload.companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(bankTransactionListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBankTransactionListFailure(responseData.data));
		} else {
			yield put(getBankTransactionListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBankTransactionListFailure(error));
	}
}

export function* resetGetbankTransactionListResponse() {
	yield put(getBankTransactionListResponseChanged());
}

export function* onGetbankTransactionListDetails() {
	yield takeLatest(
		BankTransactionType.GET_BANK_TRANSACTION_LIST_START,
		bankTransactionDetailsListGet,
	);
}

export function* onGetbankTransactionListResponseReset() {
	yield takeLatest(
		BankTransactionType.GET_BANK_TRANSACTION_LIST_RESPONSE_RESET,
		resetGetbankTransactionListResponse,
	);
}
/** *********************  END GET BANK TRANSACTION LIST ******************** */

/** *********************  START ADD BANK TRANSACTION DETAILS  ******************** */
export function* createbankTransaction({ payload }: any) {
	try {
		const key = 'CreateTranscationEntryKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			InfogID: payload.companyID,
			EntryDate: payload.EntryDate,
			CreatedFor: payload.userID,
			ToBranchID: payload.branchID,
			AccountID: payload.companyID,
			TransactionType: 'Bank',
			TotalAmount: payload.TotalAmount,
			InfogCompanyID: payload.infogCompanyID,
			CreatedBy: payload.userID,
			TransactionImage: payload.img,
			IsLoanCollection: '0',
			UserName: payload.userName,
			TranscationArr: payload.entries || [],
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(bankTransactionDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBankTransactionDetailsFailure(responseData.data));
		} else {
			yield put(addBankTransactionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBankTransactionDetailsFailure(error));
	}
}

export function* resetAddbankTransactionResponse() {
	yield put(addBankTransactionDetailsResponseChanged());
}

export function* onCreatebankTransactionDetails() {
	yield takeLatest(BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_START, createbankTransaction);
}

export function* onCreatebankTransactionResponseReset() {
	yield takeLatest(
		BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_RESPONSE_RESET,
		resetAddbankTransactionResponse,
	);
}
/** *********************  END ADD BANK_TRANSACTION DETAILS ******************** */

/** *********************  START UPDATE BANK_TRANSACTION DETAILS  ******************** */
export function* bankTransactionUpdate({ payload }: any) {
	try {
		const key = 'UpdateTransactionKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			InfogID: payload.companyID,
			EntryDate: payload.EntryDate,
			CreatedFor: payload.userID,
			ToBranchID: payload.branchID,
			AccountID: payload.companyID,
			TransactionType: 'Bank',
			TotalAmount: payload.TotalAmount,
			InfogCompanyID: payload.infogCompanyID,
			CreatedBy: payload.userID,
			TransactionImage: payload.imageUrl,
			IsLoanCollection: '0',
			UserName: payload.userName,
			TranscationArr: payload.entries || [],
			TransactionID: payload.transactionID,
			ModifiedBy: payload.userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(bankTransactionDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBankTransactionDetailsFailure(responseData.data));
		} else {
			yield put(updateBankTransactionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBankTransactionDetailsFailure(error));
	}
}

export function* resetUpdatebankTransactionDetailsResponse() {
	yield put(updateBankTransactionDetailsResponseChanged());
}

export function* onUpdatebankTransactionDetails() {
	yield takeLatest(
		BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_START,
		bankTransactionUpdate,
	);
}

export function* onUpdatebankTransactionResponseReset() {
	yield takeLatest(
		BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_RESPONSE_RESET,
		resetUpdatebankTransactionDetailsResponse,
	);
}
/** *********************  END UPDATE BANK_TRANSACTION DETAILS ******************** */

/** *********************  START DELETE BANK_TRANSACTION DETAILS  ******************** */
export function* bankTransactionDelete({ payload }: any) {
	try {
		const key = 'DeleteTransactionKey';
		const jsonData = {
			TransactionType: payload.type,
			BranchID: payload.BranchID,
			UserID: payload.userID,
			UserName: payload.userID,
			InfogID: payload.companyID,
			AccountID: payload.AccountID,
			TransactionID: payload.TransactionID,
			DatabaseName: payload.databaseName,
			AccountName: payload.AccountName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(bankTransactionDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteBankTransactionDetailsFailure(responseData.data));
		} else {
			yield put(deleteBankTransactionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteBankTransactionDetailsFailure(error));
	}
}

export function* resetDeletebankTransactionDetailsResponse() {
	yield put(deleteBankTransactionDetailsResponseChanged());
}

export function* onDeletebankTransactionDetail() {
	yield takeLatest(
		BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_START,
		bankTransactionDelete,
	);
}

export function* onDeletebankTransactionResponseReset() {
	yield takeLatest(
		BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_RESPONSE_RESET,
		resetDeletebankTransactionDetailsResponse,
	);
}
/** *********************  END DELETE BANK_TRANSACTION DETAILS ******************** */

/** *********************  START FETCH BANK_TRANSACTION DETAILS  ******************** */
export function* fetchbankTransactionData({ payload }: any) {
	try {
		const key = 'FetchParticularTransactionKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			UserAccessBranchID: payload.companyID,
			ViewUser: payload.viewUser,
			CompanyID: payload.companyID,
			Type: payload.type,
			InfogID: payload.companyID,
			bankTransactionID: payload.TransactionID,
			SearchType: payload.SearchType,
			BranchID: payload.branchId,
			primaryAccountID: payload.companyID,
			accountNameForVoucher: 'Bank',
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(bankTransactionDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBankTransactionDetailsFailure(responseData.data));
		} else {
			yield put(fetchBankTransactionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBankTransactionDetailsFailure(error));
	}
}

export function* resetFetchbankTransactionDetailsResponse() {
	yield put(fetchBankTransactionDetailsResponseChanged());
}

export function* onFetchbankTransactionDetails() {
	yield takeLatest(
		BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_START,
		fetchbankTransactionData,
	);
}

export function* onFetchbankTransactionResponseReset() {
	yield takeLatest(
		BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_RESPONSE_RESET,
		resetFetchbankTransactionDetailsResponse,
	);
}
/** *********************  END FETCH BANK_TRANSACTION DETAILS ******************** */

/** *********************  START GET MODEL VALUES LIST  ******************** */
export function* modelValuesGet({ payload }: any) {
	try {
		const key = 'GetModelValuesKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			CompanyID: payload.asOnDate,
			BranchID: payload.asOnDate,
			TransactionID: payload.asOnDate,
			FromAccountID: payload.infogCompanyID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(modelValues, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getModelValuesFailure(responseData.data));
		} else {
			yield put(getModelValuesSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getModelValuesFailure(error));
	}
}

export function* resetGetModelValuesResponse() {
	yield put(getModelValuesResponseChanged());
}

export function* onGetModelValuesDetails() {
	yield takeLatest(BankTransactionType.GET_VALUES_MODEL_START, modelValuesGet);
}

export function* onGetModelValuesResponseReset() {
	yield takeLatest(
		BankTransactionType.GET_VALUES_MODEL_RESPONSE_RESET,
		resetGetModelValuesResponse,
	);
}
/** *********************  END GET MODEL VALUES LIST ******************** */

/** *********************  START CHECK BRANCH EOD VALUES LIST  ******************** */
export function* checkBranchEOD({ payload }: any) {
	try {
		const key = 'GetParticularBranchEODListKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			CompanyID: payload.asOnDate,
			FromBranchID: payload.asOnDate,
			EODDate: payload.infogCompanyID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(checkBranchEodValues, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkBranchEODFailure(responseData.data));
		} else {
			yield put(checkBranchEODSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkBranchEODFailure(error));
	}
}

export function* resetCheckBranchEODValuesResponse() {
	yield put(checkBranchEODChanged());
}

export function* onCheckBranchEODResponseDetails() {
	yield takeLatest(BankTransactionType.CHECK_BRANCH_EOD_START, checkBranchEOD);
}

export function* onCheckBranchEODResponseReset() {
	yield takeLatest(
		BankTransactionType.CHECK_BRANCH_EOD_RESPONSE_RESET,
		resetCheckBranchEODValuesResponse,
	);
}
/** *********************  ENDCHECK BRANCH EOD VALUES LIST ******************** */

/** *********************  START CHECK BRANCH EOD VALUES LIST  ******************** */
export function* selectedApproveTransaction({ payload }: any) {
	try {
		const key = 'ApprovalUpdateCashTransactionKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			RejectNotes: payload.RejectNotes,
			isStatus: payload.isStatus,
			transactionID: payload.transactionID,
			MemberApprovedBy: payload.userID,
			UserName: payload.userName,
			TransactionType: payload.TransactionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(UpdateTransactionValues, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(selectedTransactionApproveFailure(responseData.data));
		} else {
			yield put(selectedTransactionApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(selectedTransactionApproveFailure(error));
	}
}

export function* resetSelectedApproveTransactionResponse() {
	yield put(selectedTransactionApproveChanged());
}

export function* onSelectedApprovedTransactionDetails() {
	yield takeLatest(
		BankTransactionType.SELECTED_TRANSACTION_APPROVE_START,
		selectedApproveTransaction,
	);
}

export function* onSelectedApprovedTransactionResponseReset() {
	yield takeLatest(
		BankTransactionType.SELECTED_TRANSACTION_APPROVE_RESET,
		resetSelectedApproveTransactionResponse,
	);
}
/** *********************  END CHECK BRANCH EOD VALUES LIST ******************** */

export function* bankTransactionSaga() {
	yield all([
		call(onCreatebankTransactionDetails),
		call(onCreatebankTransactionResponseReset),
		call(onUpdatebankTransactionDetails),
		call(onUpdatebankTransactionResponseReset),
		call(onGetbankTransactionListDetails),
		call(onGetbankTransactionListResponseReset),
		call(onFetchbankTransactionDetails),
		call(onFetchbankTransactionResponseReset),
		call(onDeletebankTransactionDetail),
		call(onDeletebankTransactionResponseReset),
		call(onGetModelValuesDetails),
		call(onGetModelValuesResponseReset),
		call(onCheckBranchEODResponseReset),
		call(onCheckBranchEODResponseDetails),
		call(onSelectedApprovedTransactionResponseReset),
		call(onSelectedApprovedTransactionDetails),
	]);
}
